import { mergeToNewObject } from './object.helpers'
import { trim } from './string.helpers'

const transWithArgs = (t, messageWithArgs) => {
  if (messageWithArgs) {
    const { message, args } = messageWithArgs
    return t(message, args)
  }
  return ''
}

const checkRulesAgainstValue = (rules, value) => {
  if (rules && rules.length > 0) {
    return rules.map((rule) => rule(value)).filter((msg) => msg !== '')
  }
  return []
}

const formatValidator = (message, args) => {
  return { message, args }
}

const checkValidations = (fields) => {
  const newErrorMessages = Object.entries(fields).reduce((curr, next) => {
    const { value, rules } = next[1]
    const invalid = checkRulesAgainstValue(rules, value)?.[0]
    if (invalid) {
      return mergeToNewObject(curr, { [next[0]]: invalid })
    }
    return curr
  }, {})

  return newErrorMessages
}

const requiredRule = (value) => {
  return !isValidRequired(value)
    ? formatValidator('staking.required-field')
    : ''
}

const isValidRequired = (value) => {
  return value && trim(String(value)).length
}

const isValidUUID = (number) => {
  const valid =
    /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi
  return valid.test(number)
}

const UUIDRule = (accountNumber) => {
  return !isValidUUID(accountNumber)
    ? formatValidator('staking.invalid-account-number')
    : ''
}

export {
  transWithArgs,
  checkRulesAgainstValue,
  checkValidations,
  requiredRule,
  formatValidator,
  UUIDRule
}
